import * as Sentry from '@sentry/nextjs'
import type { CaptureContext } from '@sentry/types'

export const SentryCaptureException = (
  exception: any,
  captureContext?: CaptureContext,
) => {
  Sentry.captureException(exception, captureContext)
}
